<!-- 农事信息组件 -->
<template>
    <div class="pageContent">
        <template v-if="farmInfo.length > 0">
            <div class="cardItem" v-for="item in farmInfo" :key="item.id">
                <CommonRow :title="$t('page.farmingInfo.farmTitle')">
                    <div class="whiteCard">
                        <div class="whiteCardText">{{ item.name || "-" }}</div>
                    </div>
                    <div class="farmBox">
                        <CommonCard :title="$t('page.farmingInfo.farmUser')" :content="`${item.personnelName || '-'}`"
                            :icon="'icon-yuangongfuzeren'" :iconSize="'26px'" :hasBg="false"
                            :iconColor="'rgba(42, 130, 228, 0.15)'" />
                        <CommonCard :title="$t('page.farmingInfo.farmMaterial')" :content="`${item.materialName || '-'}`"
                            :icon="'icon-wuliao-wuliaoguanli'" :iconSize="'26px'" :hasBg="false"
                            :iconColor="'rgba(255, 141, 26, 0.15)'" />
                        <CommonCard :title="$t('page.farmingInfo.targetCrop')" :content="`${item.plantName || '-'}`"
                            :icon="'icon-zhongzhizuowu'" :iconSize="'26px'" :hasBg="false"
                            :iconColor="'rgba(255, 219, 219, 1)'" />
                        <CommonCard :title="$t('page.farmingInfo.farmTime')" :content="`${item.jobTime || '-'}`"
                            :icon="'icon-shijian'" :iconSize="'26px'" :hasBg="false" :iconColor="'rgba(0, 186, 173, 0.15)'" />
                        <CommonCard :title="$t('page.farmingInfo.farmMachine')" :content="`${item.machineryName || '-'}`"
                            :icon="'icon-nongji'" :iconSize="'26px'" :hasBg="false" :iconColor="'rgba(217, 227, 240, 1)'" />
                    </div>
                </CommonRow>
                <CommonRow :title="$t('page.farmingInfo.farmImage')">
                    <template v-if="item.image">
                        <div class="parkImgBox">
                            <CommonImageCard v-for="(img, index) in item.image.split(',')" :key="index" :src="handleImage(img)" :width="'87px'"
                                :height="'70px'" />
                        </div>
                    </template>
                    <template v-else>
                        <CommonEmpty :description="$t('empty.noFarmImage')" />
                    </template>
                </CommonRow>
                <CommonRow :title="$t('page.farmingInfo.farmContent')">
                    <div class="whiteCard">
                        <div class="whiteCardText">{{ item.content || "-" }}</div>
                    </div>
                </CommonRow>
            </div>
        </template>
        <template v-else>
            <div class="emptyBox">
                <CommonEmpty :imageSize="'200'"></CommonEmpty>
            </div>
        </template>
    </div>
</template>

<script>
import CommonCard from '../common/commonCard.vue';
import CommonImageCard from '../common/commonImageCard.vue';
import { CODE_SUCCESS } from '../../utils/constant.js';
import { validateImageUrl } from '../../utils/index';
export default {
    components: {
        CommonCard,
        CommonImageCard,
    },
    props: {
        info: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            farmInfo: [], // 农事信息
        };
    },
    methods: {
        async refresh() {
            if (!this.info.plantId) {
                this.farmInfo = [];
                return
            }
            this.$toast.loading({
                message: this.$t("common.loading"),
                forbidClick: true,
            });
            try {
                const params = {
                    plantId: this.info.plantId
                }
                const res = await this.$api.fetchFarmPlanList(params);
                this.$toast.clear()
                if (res.code != CODE_SUCCESS) {
                    this.$toast.fail(res.msg);
                } else {
                    this.farmInfo = res.data || [];
                }
            } catch (error) {
                this.$toast.clear()
                console.error("错误", error);
            }
        },
        handleImage(image) {
            return validateImageUrl(image);
        },
    },
};
</script>

<style scoped>
.cardItem {
    width: 100%;
    height: auto;
    margin-bottom: 10px;
}

.farmBox {
    width: 100%;
    height: auto;
    margin-top: 25px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    column-gap: 21px;
    row-gap: 12px;
}

.parkImgBox {
    width: 100%;
    height: auto;
    display: flex;
    column-gap: 8px;
    overflow: hidden;
    overflow-x: auto;
    padding-bottom: 10px;
}

.emptyBox {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>